import React, { useState, useEffect } from 'react';
import '../styles/CookieBar.css';

const CookieBar: React.FC = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);

    useEffect(() => {
        // Check if user has already accepted cookies
        const cookieConsent = localStorage.getItem('cookieConsent');
        if (!cookieConsent) {
            setIsVisible(true);
            setIsPopoverOpen(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookieConsent', 'accepted');
        setIsPopoverOpen(false);
        setTimeout(() => setIsVisible(false), 300);
    };

    const handleDecline = () => {
        localStorage.setItem('cookieConsent', 'declined');
        setIsPopoverOpen(false);
        setTimeout(() => setIsVisible(false), 300);

        // Disable Google Analytics
        window['ga-disable-G-XJ4E97XD3V'] = true;
    };

    const togglePopover = () => {
        setIsPopoverOpen(!isPopoverOpen);
    };

    if (!isVisible) return null;

    return (
        <div className="cookie-bar">
            <button
                className="cookie-button"
                onClick={togglePopover}
                aria-label="Cookie settings"
            >
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17316C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92893 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8078C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17316C20.7362 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.76121C14.6136 2.25866 13.3132 2 12 2ZM12 20C10.4178 20 8.87104 19.5308 7.55544 18.6518C6.23985 17.7727 5.21447 16.5233 4.60897 15.0615C4.00347 13.5997 3.84504 11.9911 4.15372 10.4393C4.4624 8.88743 5.22433 7.46197 6.34315 6.34315C7.46197 5.22433 8.88743 4.4624 10.4393 4.15372C11.9911 3.84504 13.5997 4.00347 15.0615 4.60897C16.5233 5.21447 17.7727 6.23985 18.6518 7.55544C19.5308 8.87104 20 10.4178 20 12C20 14.1217 19.1571 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20Z"
                        fill="currentColor"
                    />
                    <circle cx="8" cy="9" r="1.5" fill="currentColor"/>
                    <circle cx="15" cy="10" r="1.5" fill="currentColor"/>
                    <circle cx="12" cy="14" r="1.5" fill="currentColor"/>
                    <circle cx="9" cy="16" r="1" fill="currentColor"/>
                    <circle cx="15" cy="15" r="1" fill="currentColor"/>
                </svg>
            </button>

            {isPopoverOpen && (
                <div className="cookie-popover">
                    <div className="cookie-popover-content">
                        <h3>🍪 We use cookies</h3>
                        <p>
                            We use Google Analytics to understand how visitors interact with our website.
                            This helps us improve your experience.
                        </p>
                        <div className="cookie-actions">
                            <button className="cookie-btn cookie-btn-accept" onClick={handleAccept}>
                                Accept
                            </button>
                            <button className="cookie-btn cookie-btn-decline" onClick={handleDecline}>
                                Decline
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CookieBar;